<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="document"
                                    v-model="form.document"
                                    label="Número de RUC"
                                    outlined
                                    dense
                                    :rules="[() => !!form.document || 'Es necesario ingresar número de ruc.']"
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    ref="name"
                                    v-model="form.name"
                                    label="Razón Social"
                                    outlined
                                    dense
                                    :rules="[() => !!form.name || 'Es necesario ingresar la razón social.']"
                                    hide-details="auto"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="form.phone"
                                    label="Teléfono"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Email"
                                    v-model="form.email"
                                    outlined
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    v-model="form.address"
                                    label="Dirección"
                                    outlined
                                    dense
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>                
            </v-card>
            <div class="mt-3" style="text-align: right;">
                <template>
                    <v-row>
                        <v-col cols="6">
                            <v-btn @click="handleCancel" 
                                block 
                                dark
                                color="red">
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn v-if="actionCrud=='create'" 
                                dark 
                                color="green" 
                                block
                                @click="handleCreateProvider">
                                Guardar
                            </v-btn>
                            <v-btn v-else 
                                dark 
                                color="blue" 
                                block
                                @click="handleUpdateProvider">
                                Actualizar
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'CreateProvider',
    data() {
        return {
            actionCrud: '',
            titleForm: '',
            drawer: false,
            form: {
                id: null,
                document: null,
                name: null,
                phone: null,
                email: null,
                address: null
            }            
        }
    },
    computed: {
        ...mapState('provider', [
            'provider'
        ])
    },
    methods: {
        ...mapActions('provider', [
            'runSetProvider',
            'getProviders'
        ]),
        async clearData() {
            this.form.id = null
            this.form.document = null
            this.form.name = null
            this.form.phone = null
            this.form.email = null
            this.form.address = null
            await this.clearErrors();
        },
        showForm(title, action) {
            this.clearData()
            this.actionCrud = action
            this.titleForm = title
            this.drawer = !this.drawer
            if(this.actionCrud === 'create'){
                this.runSetProvider(null)
            } else if(this.actionCrud === 'update'){
                this.setFormData(this.provider)
            }
        },
        setFormData(provider){            
            this.form.id = provider.id
            this.form.document = provider.document
            this.form.name = provider.name
            this.form.phone = provider.phone
            this.form.email = provider.email
            this.form.address = provider.address
        },
        handleCancel(){
            this.clearData()
            this.drawer = false
        },
        handleCreateProvider(){
            if (!this.existErrors()) {
                let newProvider = Object.assign({}, this.form);
                apiService.createProviders(newProvider).then((response) => {
                    this.drawer = false
                    this.getProviders()
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE REGISTRO DE PROVEEDOR',
                        text: 'El proveedo se registró de forma exitosa!'
                    })
                }).catch( function(error){
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE REGISTRO DE PROVEEDOR',
                        text: 'Se detectó un error al registrar proveedor'
                    })
                });
            }
        },
        handleUpdateProvider(){
            if (!this.existErrors()) {
                let updateProvider = Object.assign({}, this.form);
                apiService.updateProvider(updateProvider.id, updateProvider).then((response) => {
                    this.drawer = false
                    this.getProviders()
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'RESULTADO DE ACTUALIZACIÓN DE PROVEEDOR',
                        text: 'El proveedo se actualizó de forma exitosa!'
                    })
                }).catch( function(error){
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'RESULTADO DE ACTUALIZACIÓN DE PROVEEDOR',
                        text: 'Se detectó un error al actualizar proveedor'
                    })
                });
            }            
        },
        existErrors(){
            let hasErrors = false;

            Object.keys(this.form).forEach(f => {                
                if (this.$refs[f]) {
                    if (!this.form[f]) hasErrors = true
                    this.$refs[f].validate(true);
                }                
            });

            return hasErrors;
        },
        clearErrors() {
            Object.keys(this.form).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        }
    },
}
</script>

<style scoped>

</style>